const BannersApi = {
    getList() {
        return axios.get("/admin/banner").then(resp => resp.data.success);
    },
    get(id) {
        return axios.get(`/admin/banner/${id}`).then(resp => resp.data.success);
    },
    add(formData) {
        return axios
            .post("/admin/banner", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(resp => resp.data.success);
    },
    remove(id) {
        return axios.delete(`/admin/banner/${id}`).then(resp => resp.data.success);
    },
    update(id, formData) {
        return axios
            .post(`/admin/banner/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(resp => resp.data.success);
    },

    getUsersList() {
        return axios.get("/banners").then(resp => resp.data.success);
    },
};

export default BannersApi;
